import { render, staticRenderFns } from "./bar2.vue?vue&type=template&id=6b87954e&"
import script from "./bar2.vue?vue&type=script&lang=js&"
export * from "./bar2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports